import styled from '@emotion/styled'
export const WrapperHeader = styled.section`
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(236, 73, 73, 0.7);
  z-index: 9;
`
export const AgentLoginAction = styled.div`
  margin-left: 15px;
  display: flex;
  height: 100%;
  align-items: center;
  button:first-of-type {
    margin-right: 10px;
  }
  .processing-title {
    color: black !important;
    background-color: #ffffff !important;
    padding: 0 10px;
    line-height: 29px;
    margin: 0 10px 0 0;
  }
`
